import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../static/pol_log.png";
import "./Navigation.css";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "About", path: "/about" },
];

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMobileMenuOpen]);

  return (
    <>
      <nav className={`nav ${isScrolled ? "nav-scrolled" : ""}`}>
        <div className="nav-container">
          {/* Logo */}
          <Link to="/" className="nav-logo">
            <img src={Logo} alt="Polania Construction" />
          </Link>

          {/* Desktop Links */}
          <div className="nav-links">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`nav-link ${location.pathname === link.path ? "active" : ""}`}
              >
                {link.name}
                <span className="nav-link-underline"></span>
              </Link>
            ))}
          </div>

          {/* Contact Info + CTA */}
          <div className="nav-right">
            <div className="nav-contact">
              <a href="tel:7322050086" className="nav-phone">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                (732) 205-0086
              </a>
            </div>
            <Link to="/estimate" className="nav-cta">
              FREE ESTIMATE
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`nav-mobile-toggle ${isMobileMenuOpen ? "open" : ""}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="toggle-line"></span>
            <span className="toggle-line"></span>
            <span className="toggle-line"></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-content">
          <div className="mobile-menu-links">
            {navLinks.map((link, index) => (
              <Link
                key={link.name}
                to={link.path}
                className="mobile-menu-link"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/estimate"
              className="mobile-menu-link cta"
              style={{ animationDelay: `${navLinks.length * 0.1}s` }}
            >
              Get Free Estimate
            </Link>
          </div>
          <div className="mobile-menu-footer">
            <a href="tel:7322050086" className="mobile-phone">
              (732) 205-0086
            </a>
            <a href="tel:7325258118" className="mobile-phone">
              (732) 525-8118
            </a>
            <p className="mobile-tagline">Central New Jersey</p>
          </div>
        </div>
      </div>
    </>
  );
}
